/**
 * Финальный CTA блок на главной — последнее что видит посетитель
 * перед footer.  Должен максимизировать конверсию.
 * Languages: en, ru, es, hy, fr, de, it.
 */
export type Translations = {
    tagline: string
    title: string
    subtitle: string
    ctaPrimary: string
    ctaSecondary: string
    benefit1: string
    benefit2: string
    benefit3: string
    benefit4: string
    riskNote: string
}

const translations: Record<string, Translations> = {
    en: {
        tagline: 'NO COMMITMENT · NO CREDIT CARD',
        title: 'Ready to let the algorithm trade for you?',
        subtitle:
            'Join thousands of traders who replaced screen time with results. Set up takes 10 minutes, your robot runs 24/7 on Binance, Bybit, OKX or Rithmic.',
        ctaPrimary: 'Get Started Free',
        ctaSecondary: 'Try the Demo',
        benefit1: 'Free to start',
        benefit2: 'Read & Trade API only',
        benefit3: 'Funds stay on your exchange',
        benefit4: 'Cancel anytime',
        riskNote:
            'Trading involves risk. Past performance is not indicative of future results. Start with a small deposit you can afford to test.',
    },
    ru: {
        tagline: 'БЕЗ ОБЯЗАТЕЛЬСТВ · БЕЗ КАРТЫ',
        title: 'Готовы доверить торговлю алгоритму?',
        subtitle:
            'Присоединяйтесь к тысячам трейдеров, которые заменили часы у экрана на результат. Настройка 10 минут, робот работает 24/7 на Binance, Bybit, OKX или Rithmic.',
        ctaPrimary: 'Начать бесплатно',
        ctaSecondary: 'Попробовать демо',
        benefit1: 'Бесплатный старт',
        benefit2: 'Только Read & Trade API',
        benefit3: 'Средства на вашей бирже',
        benefit4: 'Отмена в любой момент',
        riskNote:
            'Торговля связана с риском. Прошлые результаты не гарантируют будущих. Начните с небольшого депозита для теста.',
    },
    es: {
        tagline: 'SIN COMPROMISO · SIN TARJETA',
        title: '¿Listo para dejar que el algoritmo opere por ti?',
        subtitle:
            'Únete a miles de traders que reemplazaron horas frente a la pantalla por resultados. Configuración en 10 minutos, tu robot opera 24/7 en Binance, Bybit, OKX o Rithmic.',
        ctaPrimary: 'Empezar gratis',
        ctaSecondary: 'Probar Demo',
        benefit1: 'Empieza gratis',
        benefit2: 'API solo Read & Trade',
        benefit3: 'Fondos en tu exchange',
        benefit4: 'Cancela cuando quieras',
        riskNote:
            'El trading conlleva riesgo. Los resultados pasados no garantizan resultados futuros. Comienza con un depósito pequeño para probar.',
    },
    hy: {
        tagline: 'ԱՌԱՆՑ ՊԱՐՏԱՎՈՐՈՒԹՅԱՆ · ԱՌԱՆՑ ՔԱՐՏԻ',
        title: 'Պատրա՞ստ եք վստահել առևտուրը ալգորիթմին։',
        subtitle:
            'Միացեք հազարավոր թրեյդերներին, ովքեր էկրանի ժամերը փոխարինել են արդյունքներով։ Կարգավորում 10 րոպեում, ռոբոտն աշխատում է 24/7 Binance, Bybit, OKX կամ Rithmic-ում։',
        ctaPrimary: 'Սկսել անվճար',
        ctaSecondary: 'Փորձել Դեմո',
        benefit1: 'Անվճար մեկնարկ',
        benefit2: 'Միայն Read & Trade API',
        benefit3: 'Միջոցները ձեր բորսայում',
        benefit4: 'Չեղարկում ցանկացած ժամանակ',
        riskNote:
            'Առևտուրը կապված է ռիսկի հետ։ Անցյալի արդյունքները չեն երաշխավորում ապագան։ Սկսեք փոքր դեպոզիտով՝ փորձելու համար։',
    },
    de: {
        tagline: 'OHNE VERPFLICHTUNG · OHNE KREDITKARTE',
        title: 'Bereit, den Algorithmus für Sie handeln zu lassen?',
        subtitle:
            'Schließen Sie sich Tausenden Tradern an, die Bildschirmzeit durch Ergebnisse ersetzt haben. Einrichtung in 10 Minuten, Ihr Roboter läuft 24/7 auf Binance, Bybit, OKX oder Rithmic.',
        ctaPrimary: 'Kostenlos starten',
        ctaSecondary: 'Demo testen',
        benefit1: 'Kostenloser Start',
        benefit2: 'Nur Read & Trade API',
        benefit3: 'Mittel auf Ihrer Börse',
        benefit4: 'Jederzeit kündbar',
        riskNote:
            'Handel ist mit Risiken verbunden. Vergangene Ergebnisse garantieren keine zukünftigen. Beginnen Sie mit einem kleinen Test-Deposit.',
    },
    fr: {
        tagline: 'SANS ENGAGEMENT · SANS CARTE',
        title: 'Prêt à laisser l\'algorithme trader pour vous ?',
        subtitle:
            'Rejoignez des milliers de traders qui ont remplacé les heures d\'écran par des résultats. Configuration en 10 minutes, votre robot tourne 24/7 sur Binance, Bybit, OKX ou Rithmic.',
        ctaPrimary: 'Commencer gratuitement',
        ctaSecondary: 'Essayer la Démo',
        benefit1: 'Démarrage gratuit',
        benefit2: 'API Read & Trade uniquement',
        benefit3: 'Fonds sur votre exchange',
        benefit4: 'Annulation à tout moment',
        riskNote:
            'Le trading comporte des risques. Les performances passées ne garantissent pas les résultats futurs. Commencez avec un petit dépôt pour tester.',
    },
    it: {
        tagline: 'NESSUN IMPEGNO · NESSUNA CARTA',
        title: 'Pronto a lasciare che l\'algoritmo operi per te?',
        subtitle:
            'Unisciti a migliaia di trader che hanno sostituito le ore davanti allo schermo con risultati. Configurazione in 10 minuti, il tuo robot opera 24/7 su Binance, Bybit, OKX o Rithmic.',
        ctaPrimary: 'Inizia gratis',
        ctaSecondary: 'Prova la Demo',
        benefit1: 'Inizio gratuito',
        benefit2: 'API solo Read & Trade',
        benefit3: 'Fondi sul tuo exchange',
        benefit4: 'Annulla quando vuoi',
        riskNote:
            'Il trading comporta rischi. Le performance passate non garantiscono i risultati futuri. Inizia con un piccolo deposito di prova.',
    },
}

export default translations
